import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { HEADING_LEVELS, HEADING_TYPES } from '../constants';
import { headingVariantStyles } from '../variant-styles';

const StyledHeading = styled.h2`
  ${({ $variant }) =>
    $variant &&
    css`
      ${headingVariantStyles[$variant]};
    `}
`;

const Heading = ({ children, level = HEADING_LEVELS.LEVEL_2, type = HEADING_TYPES.DISPLAY_1, ...other }) => {
  const Tag = `h${Math.min(level, 6)}`;

  return (
    <StyledHeading as={Tag} $variant={type} {...other}>
      {children}
    </StyledHeading>
  );
};

Heading.propTypes = {
  /** Adds any content between tags */
  children: PropTypes.node,
  /** Sets the heading styles. */
  type: PropTypes.oneOf(Object.values(HEADING_TYPES)),
  /** Sets heading tag level (depth) and applies style. Values: [1, 2, 3, 4, 5, 6] */
  level: PropTypes.oneOf(Object.values(HEADING_LEVELS)),
};

export { Heading };
